var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" 找不到页面哦 "),_c('span',[_vm._v(_vm._s(_vm.time))]),_vm._v(" 秒后返回搜索页面 "),_c('button',{on:{"click":_vm.goPage}},[_vm._v("返回搜索")])])}
var staticRenderFns = []

export { render, staticRenderFns }